module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-b2e51339a617da1cafe9b4a1c0d5d66f.webp";